import { render } from "./MvehiclesCreate.vue?vue&type=template&id=071577a0&scoped=true"
import script from "./MvehiclesCreate.vue?vue&type=script&lang=js"
export * from "./MvehiclesCreate.vue?vue&type=script&lang=js"

import "./MvehiclesCreate.vue?vue&type=style&index=0&id=071577a0&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071577a0"]])

export default __exports__